var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardGeneral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DB44AE96-0FE3-4C48-B02A-B39EA8112576") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contact-us",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-us---General",
    transform: "translate(-270.000000, -459.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy",
    transform: "translate(250.000000, 439.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card_general",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0833333,38.3963267 L17.8124746,44.562912 C16.4374745,45.4795786 14.5833333,44.5005036 14.5833333,42.8338369 L14.5833333,38.3963267 C8.33333333,38.3963267 4.16666667,34.22966 4.16666667,27.97966 L4.16666667,15.4795329 C4.16666667,9.22953288 8.33333333,5.06286621 14.5833333,5.06286621 L35.4166667,5.06286621 C41.6666667,5.06286621 45.8333333,9.22953288 45.8333333,15.4795329 L45.8333333,27.97966 C45.8333333,34.22966 41.6666667,38.3963267 35.4166667,38.3963267 L27.0833333,38.3963267 Z",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001272,23.6663818 L25.0001272,23.2289632 C25.0001272,21.8122965 25.8751831,21.0622609 26.7501831,20.4580943 C27.6043498,19.8747609 28.4584045,19.1247864 28.4584045,17.7497864 C28.4584045,15.8331197 26.9167939,14.2913818 25.0001272,14.2913818 C23.0834605,14.2913818 21.5418498,15.8331197 21.5418498,17.7497864",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,0 L50,50 L0,50 L0,0 L50,0 Z",
    id: "Vector",
    opacity: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.990625,
    y1: 28.6458333,
    x2: 25.0093749,
    y2: 28.6458333,
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardGeneral);
export default __webpack_public_path__ + "static/media/card_general.3a2764d8fe8dcbbc68e3662d130df17c.svg";
export { ForwardRef as ReactComponent };